<template>
  <DataTable type="MyPost" title="我发布的数据需求"></DataTable>
</template>

<script>
import DataTable from "@/components/DataTable.vue";
export default {
  components: {
    DataTable,
  },}
</script>

<style scoped>

</style>